import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { Tooltip } from "../tooltip";
var ListItemContext = React.createContext({
    isDisabled: false,
    isSelected: false,
    isCurrent: false,
});
export var useListItemContext = function () { return React.useContext(ListItemContext); };
export var ListItem = forwardRef(function ListItem(_a, ref) {
    var children = _a.children, className = _a.className, current = _a.current, disabled = _a.disabled, selected = _a.selected, onClick = _a.onClick, tooltip = _a.tooltip, props = __rest(_a, ["children", "className", "current", "disabled", "selected", "onClick", "tooltip"]);
    var child = (React.createElement("li", __assign({}, props, { ref: ref, className: classNames(className, {
            "is-current": current && !selected,
            "is-disabled": disabled,
            "is-selected": selected,
        }), onClick: disabled ? null : onClick }), children));
    if (tooltip) {
        child = React.createElement(Tooltip, { title: tooltip }, child);
    }
    return child;
});
ListItem.displayName = "ListItem";
//# sourceMappingURL=ListItem.js.map